import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {toggleProductNoteEditorVisible} from "../../../actions/selectionFunctions";

const AddProductNoteEditor = (props) => {

  const {selectionFeatureInfo, productNoteEditorVisible, intl, toggleProductNoteEditorVisible, activeQuoteIndex} = props;
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [noteText, setNoteText] = useState("");

  useEffect(() => {
    if (productNoteEditorVisible) {
      setLoaded(true);
      setVisible(true);
      setNoteText(selectionFeatureInfo.notesList[activeQuoteIndex] || "");
    } else { // turn it off
      setVisible(false);
      setTimeout(() => {
        setLoaded(false);
      }, 300);
    }
  }, [productNoteEditorVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  const onNoteChange = (e) => {
    setNoteText(e.target.value);
  };

  const onNoteSaveClick = () => {
    selectionFeatureInfo.notesList[activeQuoteIndex] = noteText;
    toggleProductNoteEditorVisible(false);
  };

  if (!productNoteEditorVisible && !loaded) {
    return null
  }

  return (
    <div className={"product-note" + (visible ? " product-note--active" : "")}>
      <textarea name=""
                id=""
                cols="30"
                rows="10"
                className="product-note__textarea ui-textarea"
                placeholder={intl.formatMessage({id: "quotingTool.featureInfo.addNoteButton"})}
                value={noteText}
                onChange={onNoteChange} />
      <button className="product-note__button ui-button2 ui-button2--green" onClick={onNoteSaveClick}>
        <FormattedMessage id="quotingTool.featureInfo.saveNoteButton"/>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {selectionFeatureInfo, productNoteEditorVisible} = store.selectionState;
  return {
    selectionFeatureInfo,
    productNoteEditorVisible,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
  };
};

const mapDispatchToProps = {
  toggleProductNoteEditorVisible
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AddProductNoteEditor)
);
